module.exports = __webpack_public_path__ + "static/media/upcoming-events-header@3x.9bd9a29e.jpg";